import React from 'react';
import {
    Alert,
    AlertIcon,
    Box,
} from '@chakra-ui/react';

/** Chakra `Alert` uses `ComponentWithAs` + deep theme unions; TS can exceed union depth on JSX inference. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AlertRoot = Alert as any;

export type Props = {
    notification: {
        id: string;
        type: 'info' | 'warning' | 'success' | 'error';
        title: string;
        message?: string;
    }
};

type MessageBodyProps = Readonly<{
    text: string;
}>;

function MessageBody({ text }: MessageBodyProps) {
    const lines = text.split('\n');
    let lineStart = 0;
    return (
        <Box fontSize="sm" mt={1}>
            {lines.map((line) => {
                const key = `msg-line-${lineStart}`;
                lineStart += line.length;
                if (lineStart < text.length) {
                    lineStart += 1;
                }
                return (
                    <Box key={key} as="span" display="block" lineHeight="1.4">
                        {line.length > 0 ? line : '\u00a0'}
                    </Box>
                );
            })}
        </Box>
    );
}

export const Notification = ({ notification: { type, title, message } }: Props) => {
    return (
        <AlertRoot
            status={type}
            variant="solid"
            transition=".2s ease-in-out"
            w="full"
            borderRadius={4}
            bgColor={type === 'success' ? 'brand.blue' : undefined}
            alignItems="flex-start"
            overflow="visible"
            py={3}
        >
            <AlertIcon mt={0.5} flexShrink={0} />
            <Box flex="1" minW={0}>
                {title}
                {message ? <MessageBody text={message} /> : null}
            </Box>
        </AlertRoot>
    );
};
